import * as React from 'react';
import type { SVGProps } from 'react';
const SvgChevronRight = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		viewBox="0 0 24 24"
		{...props}
	>
		<polyline stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" points="9 18 15 12 9 6" />
	</svg>
);
export default SvgChevronRight;
